
/* eslint-disable no-unused-vars */
import { defineComponent, ref, computed, watch, onMounted } from "vue";
import { store } from "@/store";
import { zoomValue, setZoomValue, setIsZooming } from "@/canvas-api/Zoom";
import usePickr from "@/composables/usePickr";
import useSlider from "@/composables/useSlider";
import { onBoardingZoomSliderRef } from "@/onboarding/Refs"
import { ActionTypes } from "@/store/actions";
import { CurrentLabel, ColorPickrState } from "@/types";

export default defineComponent({
  setup() {
    const currentLabelBgColor = computed(() => store.getters.currentLabelBgColor);
    const colorPickrState = computed<ColorPickrState>(() => store.getters.colorPickrState);

    //Handles validating the payload and updating the store with the current color picker state
    const handleToggleColorPickr = (event: { target: HTMLButtonElement }): void => {
      const target = event.target;
      const id = "canvas-bg-color";

      if (id) {
        let payload = {
          ...colorPickrState.value,
          isOpen: false,
          id: id,
          property: {
            name: "fill",
            value: target.style.backgroundColor,
          },
        };

        usePickr(payload);
      } else {
        throw new Error("Missing target id!, BottomToolBar.vue");
      }
    };

    //Open/closes Orientation input
    const openOrientation = ref(false);
    const openOrientationSelect = (): void => {
      openOrientation.value = !openOrientation.value;
    };

    //Handles rendering correct orientation and updating the store with canvas orientation
    const displayOrientation = ref("");
    const getDefaultOrientation = computed<string>(() =>
      store.getters.currentLabel.width >= store.getters.currentLabel.height
        ? "Landscape"
        : "Portrait"
    );
    const isRotated = computed<boolean>(() =>
      store.getters.canvasOrientation === "rotated" ? true : false
    );
    onMounted(() => {
      if (isRotated.value) {
        displayOrientation.value =
          getDefaultOrientation.value === "Landscape" ? "Portrait" : "Landscape";
      } else {
        displayOrientation.value = getDefaultOrientation.value;
      }
    });

    const currentLabel = computed<CurrentLabel>(() => store.getters.currentLabel);
    watch(currentLabel, () => {
      if (isRotated.value) {
        displayOrientation.value =
          getDefaultOrientation.value === "Landscape" ? "Portrait" : "Landscape";
      } else {
        displayOrientation.value = getDefaultOrientation.value;
      }
    });

    const alternateOrientation = computed<string>(() =>
      displayOrientation.value === "Landscape" ? "Portrait" : "Landscape"
    );
    const rotateOrientation = computed<string>(() =>
      store.getters.canvasOrientation === "default" ? "rotated" : "default"
    );
    const choseOrientation = async (orientation: string): Promise<void> => {
      if (orientation !== displayOrientation.value) {
        await store.dispatch(ActionTypes.SET_CANVAS_ORIENTATION, rotateOrientation.value);

        displayOrientation.value = orientation;
        openOrientation.value = !openOrientation.value;
      }
    };

    //Handles updating the canvas current zoom values
    const zoomSlider = ref<HTMLInputElement>();
    const handleZoom = (e: { target: HTMLInputElement }): void => {
      const value = useSlider(e.target.value, zoomSlider);

      if (value !== undefined) {
        setZoomValue(value);
      }
    };

    const handleMouseDownZoom = () => {
      setIsZooming(true);
    };

    const handleMouseUpZoom = () => {
      setIsZooming(false);
    };

    return {
      currentLabelBgColor,
      handleToggleColorPickr,
      openOrientation,
      openOrientationSelect,
      displayOrientation,
      alternateOrientation,
      choseOrientation,
      zoomSlider,
      zoomValue,
      handleZoom,
      handleMouseDownZoom,
      handleMouseUpZoom,
      onBoardingZoomSliderRef
    };
  },
});
